<template>
  <div>
    <h5
      class="filterHeader js-filters-toggle"
      :class="{ active: filterActive }"
      @click="toggleMobileMenu"
    >
      {{ $t('FilterTitle') }}
    </h5>
    <div class="sections" :class="{ visible: sectionsVisible }">
      <FilterDropDown
        v-for="(taxonomy, index) in restrictCategories(
          filtergroupids,
          tagGroups.taxonomy
        )"
        :key="taxonomy.id"
        :options="mapTags(taxonomy.id, taxonomy.tags)"
        :active="tags"
        :ref="taxonomy.id"
        :open="activeGroup[index]"
        :name="taxonomy.title"
        @inputChange="toggleFilter"
        @toggleFilters="toggleFilters(index)"
        v-on:clearTag="clearTag"
      >
      </FilterDropDown>
      <DateFilterDropDown
        :options="tagGroups.created"
        :active="datetags"
        v-if="showYearFilter"
        :name="$t('PublishDate')"
        @inputChange="toggleDateFilter"
        v-on:clearTag="clearDateTag"
      >
      </DateFilterDropDown>
    </div>
  </div>
</template>

<script lang="ts">
import Vue from "vue";
import { GenericSearchResponseFacets, GenericSearchResponseFacetsCreatedItem, TaxonomyCategory  } from "../client/src/models/index";
import { ExtendedTaxonomyTag } from '../models/ExtendedTaxonomyTag';

import FilterDropDown from "./FilterDropDown.vue";
import DateFilterDropDown from "./DateFilterDropDown.vue";

export default Vue.extend({
  name: "Filters",
  props: {
    tagGroups: {
      type: Object as () => GenericSearchResponseFacets,
      required: true,
      default: () => ({}),
    },
    tags: {
      type: Array as () => ExtendedTaxonomyTag[],
      required: true,
      default: () => ([]),
    },
    datetags: {
      type: Array as () => GenericSearchResponseFacetsCreatedItem[],
      required: true,
      default: () => ([]),
    },
    showYearFilter: {
      type: Boolean,
      required: true,
      default: false,
    },
    filtergroupids: {
      type: Array as () => string[],
      required: false,
      default: () => ([]),
    },
  },
  watch: {
    tagGroups: function(val) {
      this.activeGroup = this.restrictCategories(
        this.filtergroupids,
        val.taxonomy
      ).map((x) => false);
    },
  },
  data() {
    return {
      activeGroup: this.$props.filtergroupids.map((x) => false) as boolean[],
      showmore: false as boolean,
      sectionsVisible: false as boolean,
      filterActive: false as boolean,
    };
  },
  components: {
    FilterDropDown,
    DateFilterDropDown,
  },
  methods: {
    toggleMobileMenu() {
      this.$data.sectionsVisible = !this.$data.sectionsVisible;
      this.$data.filterActive = !this.$data.filterActive;
    },
    showMoreFilters() {
      this.$data.showmore = !this.$data.showmore;
    },
    restrictCategories(
      ids: string[],
      categories?: TaxonomyCategory[]
    ): TaxonomyCategory[] {     
      if (!categories) return [];
      if (ids.length < 1) return categories;
      return categories.filter(function(
        cat: TaxonomyCategory
      ) {
        return ids.includes(cat.id.toString());
      });
    },
    toggleFilters(index: number) {
      if (this.$data.activeGroup[index]) {
        this.$set(this.$data.activeGroup, index, false);
      } else {
        this.$data.activeGroup = this.$data.activeGroup.map((x) => false);
        this.$set(this.$data.activeGroup, index, true);
      }
    },
    toggleFilter(tag: ExtendedTaxonomyTag) {
      console.log(tag, this.tags);
      if (this.tags.filter((x) => x.id === tag.id).length === 0) {
        this.tags = this.tags.filter((t: ExtendedTaxonomyTag) => t.parentId !== tag.parentId);
        this.tags.push(tag);
        this.$emit("change", this.tags);
      }
    },
    toggleDateFilter(
      tag: GenericSearchResponseFacetsCreatedItem
    ) {
      if (this.$props.datetags === undefined) return false;
      if (
        this.datetags.filter((x) => x.value === tag.value?.toString())
          .length === 0
      ) {
        this.datetags = [];
        this.datetags.push(tag);
        this.$emit("changeDate", this.datetags);
      }
    },
    clearTag(tag: ExtendedTaxonomyTag) {
      this.tags.splice(this.tags.indexOf(tag), 1);
      this.$emit("change", this.tags);
    },
    clearDateTag(tag: GenericSearchResponseFacetsCreatedItem) {
      this.datetags.splice(this.datetags.indexOf(tag), 1);
      this.$emit("changeDate", this.datetags);
    },
    mapTags(tagGroupId: number, tags: ExtendedTaxonomyTag[]) {
      return tags.map((t: ExtendedTaxonomyTag) => ({
        ...t,
        parentId: tagGroupId
      }));
    },
  },
});
</script>
